import router from '../router';

const authentication = [
  res => res,
  (err) => {
    if (err.response.status === 401 && err.response.data.identifier === 'unauthorized') {
      window.location.replace(process.env.TWENTY_LOGIN_PAGE);
    } else if (err.response.status === 404) {
      router.push({ name: 'PageNotFound' });
    } else {
      router.push({ name: 'PageNotFound' });
    }
  },
];

/* eslint-disable */
export {
  authentication,
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/interceptors/request.js